import { isKnownDomainSlug } from 'bundles/browse-common/utils/domain-utils';

export type KnownSearchTopics =
  | 'Arts and Humanities'
  | 'Business'
  | 'Computer Science'
  | 'Data Science'
  | 'Health'
  | 'Information Technology'
  | 'Language Learning'
  | 'Math and Logic'
  | 'Personal Development'
  | 'Physical Science and Engineering'
  | 'Social Sciences';

export function toSearchTopic(domainSlug = 'UNKNOWN'): KnownSearchTopics | undefined {
  if (isKnownDomainSlug(domainSlug)) {
    switch (domainSlug) {
      case 'arts-and-humanities':
        return 'Arts and Humanities';
      case 'business':
        return 'Business';
      case 'computer-science':
        return 'Computer Science';
      case 'data-science':
        return 'Data Science';
      case 'health':
        return 'Health';
      case 'information-technology':
        return 'Information Technology';
      case 'language-learning':
        return 'Language Learning';
      case 'math-and-logic':
        return 'Math and Logic';
      case 'personal-development':
        return 'Personal Development';
      case 'physical-science-and-engineering':
        return 'Physical Science and Engineering';
      case 'social-sciences':
        return 'Social Sciences';
      default:
        return domainSlug;
    }
  } else {
    return undefined;
  }
}
